export default __webpack_public_path__ + "assets/02dce0fa5f6da66faca1dadd9ee01954.svg";